module.exports = __webpack_public_path__ + "static/media/02.80c55bbc.png";